"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsNestedArray = void 0;
const class_validator_1 = require("class-validator");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
function isNonEmptyArray(value) {
    return (0, class_validator_1.isArray)(value) && (0, class_validator_1.arrayNotEmpty)(value);
}
function isStringElements(value) {
    return value.every((item) => (0, class_validator_1.isString)(item));
}
function isNestedArrayOfStringsOrArrayOfStrings(value) {
    return {
        pass: isNonEmptyArray(value) &&
            (isStringElements(value) || value.every((item) => isNonEmptyArray(item) && isStringElements(item))),
    };
}
var IsNestedArray;
(function (IsNestedArray) {
    function ofStringsOrArrayOfStrings(constraints, options) {
        return (0, mol_validator_utils_1.registerValidatorDecorator)({
            name: "IsNestedArrayOfStrings",
            defaultMessage: "should be of type string[] or string[][]",
            options,
            constraints,
            validateFn: isNestedArrayOfStringsOrArrayOfStrings,
        });
    }
    IsNestedArray.ofStringsOrArrayOfStrings = ofStringsOrArrayOfStrings;
})(IsNestedArray || (exports.IsNestedArray = IsNestedArray = {}));
//# sourceMappingURL=IsNestedArray.js.map